export default "__VITE_ASSET__CkBIeu0C__"